<template>
  <div class="d-flex align-items-center flex-column  mt-4">
    <img :src="getPhoto(user)" alt class="w-100px" />
    <div class="text">
      <h3 class="font-weight-bolder font-size-h5" style="color: #3F4254">
        {{ user.firstName }} {{ user.lastName }}
      </h3>

      <div class="text-dark-50 font-weight-bold text-center">{{ level }}</div>
      <div class="font-weight-bolder  text-center text-success">
        {{ user.points.total }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMember",
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  computed: {
    level() {
      let total = this.user.points.total > 0 ? this.user.points.total : 0;
      return this.$store.getters.getLevels.find(lvl => lvl.points <= total)
        .name;
    }
  },
  methods: {
    getPhoto(user) {
      return user?.avatar
        ? process.env.VUE_APP_API_URL + user.avatar
        : "/media/svg/avatars/001-boy.svg";
    }
  }
};
</script>

<style scoped></style>
